module.exports = __webpack_public_path__ + "static/media/selected.62cb571d.svg";